export default "__VITE_ASSET__BNee00Jo__"